import React from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQueryClient } from "react-query";
import { mealPlansAPI } from "../../services/api";
import MealPlanForm from "./MealPlanForm";
import toast from "react-hot-toast";

const CreateMealPlan = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const createMealPlanMutation = useMutation(mealPlansAPI.createMealPlan, {
    onSuccess: (data) => {
      toast.success("Meal plan created successfully!");
      queryClient.invalidateQueries("vendor-meal-plans");
      navigate("/vendor/meal-plans");
    },
    onError: (error) => {
      console.error("Error creating meal plan:", error);
      toast.error(
        error.response?.data?.message || "Failed to create meal plan"
      );
    },
  });

  const handleSave = async (formData) => {
    try {
      await createMealPlanMutation.mutateAsync(formData);
    } catch (error) {
      // Error is handled by the mutation's onError callback
      throw error;
    }
  };

  const handleCancel = () => {
    navigate("/vendor/meal-plans");
  };

  return <MealPlanForm onSave={handleSave} onCancel={handleCancel} />;
};

export default CreateMealPlan;
